import React from 'react';

export default () => <div className="custom-footer">
    <div className="custom-footer__content">
        <div className="custom-footer__copyright">
            &copy; 2021 - Third Sector Support Wales <br />
            Baltic House, Mount Stuart Square, Cardiff Bay. CF10 5FH
        </div>
    </div>
</div>;
